import React from 'react'
import './Contact.css'
import msg_icon from '../../assets/msg-icon.png'
import mail_icon from '../../assets/mail-icon.png'
import phone_icon from '../../assets/phone-icon.png'
import location_icon from '../../assets/location-icon.png'
import white_arrow from '../../assets/white-arrow.png'

const Contact = () => {
     const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "3f188389-ec19-450c-b152-f2f7efe834f0");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };




  return (
    <div className='cantact'>
      <div className="contact-col">
        <h3>Send us a message <img src={msg_icon} alt="" /></h3>
        <p>Feel free to reach out through contact form or find our contact information belew. Your feedback, questions, and suggestions are
            inportant to us as we strive to proide exceptional service to our university community.
        </p>
        <ul>
            <li><img src={mail_icon} alt="" />info@nsel.com.pk</li>
            <li><img src={phone_icon}alt="" />+92-315-2277666</li>
            <li><img src={location_icon} alt="" />Plot # 1/6 M Block 6 P.E.C.H.S Socity Karachi</li>
        </ul>
      </div>
      <div className="contact-col">
        <form onSubmit={onSubmit}>
            <label>Your name</label>
            <input type="text" name='name' placeholder='Enter your name' required/>
            <label>Phone Number</label>
             <input type="text" name='phone' placeholder='Enter your mobile number' required/>
             <label>Write your message here</label>
             <textarea name='message' rows="6" placeholder='Enter your message' required ></textarea>
             <button type='submit' className='btn dark-btn'>Submit now <img src={white_arrow} alt="" /></button>
             <span>{result}</span>
        </form>
      </div>
    </div>
  )
}

export default Contact
